import css from 'styled-jsx/css';
import { screen } from './variables';

const articlesTitleLinksCSS = css`
  .links-container {
    column-count: 1;
    column-width: 100%;
    column-gap: 3em;
    padding-bottom: 16px;
  }

  h3 {
    margin-top: 0px;
    margin-bottom: 18px;
    font-size: 14px;
    font-weight: normal;
    line-height: 1.21;
    color: #111111;
  }

  @media screen and (min-width: ${screen.smMin}) and (max-width: ${screen.smMax}) {
    .links-container {
      column-count: 2;
      column-width: 45%;
    }
  }

  @media screen and (min-width: ${screen.mdMin}) {
    .links-container {
      column-count: 3;
      column-width: 26%;
    }

    h3 {
      margin-bottom: 20px;
    }
  }
`;

export default articlesTitleLinksCSS;
